import { createContext } from 'react';

import { FastFormContextValue } from '../core';

const FastFormContext = createContext<FastFormContextValue<any> | void>(
  undefined,
);

export default FastFormContext;
